export default "__VITE_ASSET__BTk5FMWh__"